<template>
  <div>
    <BasePopup v-model="isPopupOpen" customClass="custom-popup mx-wd1000">
      <div class="popup-header">
        <h3 class="title">온라인 견적서</h3>
        <button type="button" class="btn-cancel" @click="handleClose"></button>
      </div>
      <div v-if="quoteInfo" class="popup-body" id="print-area">
        <div class="quote-title mt8 mb28">
          <h4 class="row jc-c gap24"><span>견</span><span>적</span><span>서</span></h4>
          <img src="@/assets/images/pc/header-logo.png" alt="Hcon 현대이지웰 로고" width="156" class="logo">
        </div>
        <div class="quote-top">
          <div class="quote-box">
            <p class="notice">아래와 같이 견적합니다. <span class="desc text-gray02">※ 견적 유효기간은 발행일로부터 14일입니다.</span></p>
            <div class="flex1">
              <table class="tbl-type tbl-type-row h100p">
                <caption>견적서 수신자</caption>
                <colgroup>
                  <col style="width:20%" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row" class="small left">기업명</th>
                    <td class="small left">{{ quoteInfo.buyer.name }}</td>
                  </tr>
                  <tr>
                    <th scope="row" class="small left">담당자</th>
                    <td class="small left">{{ quoteInfo.buyer.manager }}</td>
                  </tr>
                  <tr>
                    <th scope="row" class="small left">견적서명</th>
                    <td class="small left">{{ quoteInfo.title }}</td>
                  </tr>
                  <tr>
                    <th scope="row" class="small left">견적일자</th>
                    <td class="small left">{{ quoteInfo.dateKor }}</td>
                  </tr>
                  <tr>
                    <th scope="row" class="small left">견적서 번호</th>
                    <td class="small left">{{ quoteInfo.quoteNo }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="quote-box">
            <table class="tbl-type tbl-type-row h100p">
              <caption>견적서 발행자</caption>
              <colgroup>
                <col style="width:20%" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" class="small left">상호</th>
                  <td class="small left">{{ quoteInfo.provider.name }}</td>
                </tr>
                <tr>
                  <th scope="row" class="small left">성명</th>
                  <td class="small left relative">{{ quoteInfo.provider.owner }} <img src="@/assets/images/pc/sub-hcon/img-ezwel-seal.jpeg" alt="현대이지웰 인감" class="provider-seal wd65" /></td>
                </tr>
                <tr>
                  <th scope="row" class="small left">사업장주소</th>
                  <td class="small left w-pre-wrap">{{ quoteInfo.provider.address }}</td>
                </tr>
                <tr>
                  <th scope="row" class="small left">업태</th>
                  <td class="small left">{{ quoteInfo.provider.industry }}</td>
                </tr>
                <tr>
                  <th scope="row" class="small left">종목</th>
                  <td class="small left">{{ quoteInfo.provider.product }}</td>
                </tr>
                <tr>
                  <th scope="row" class="small left">담당자</th>
                  <td class="small left">{{ quoteInfo.provider.manager }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="quote-total">
          <p>최종 견적금액 <strong class="total-amount">{{ HconCommonUtils.format.addWon(quoteInfo.totalAmount) }}</strong> <span class="text-gray02 ml8">(금 {{ formatAmountKr }}원 정)</span></p>
        </div>
        
        <table class="tbl-type">
            <caption>주문 정보 확인 내역</caption>
            <colgroup>
              <col style="width: auto;">
              <col style="width: 11%;">
              <col style="width: 10%;">
              <col style="width: 12%;">
              <col style="width: 13%;">
              <col style="width: 17%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="small">상품</th>
                <th scope="col" class="small">상품단가</th>
                <th scope="col" class="small">수량</th>
                <th scope="col" class="small">상품금액</th>
                <th scope="col" class="small">할인금액</th>
                <th scope="col" class="small ta-r pr34">최종 견적금액</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <td colspan="6" class="pl34 pr34 pt24 pb24">
                  <ul class="quote-amount-list">
                    <li>
                      <span class="title">견적수량 합계</span>
                      <span class="total">{{ HconCommonUtils.format.expComma(quoteInfo.totalCount) }}</span>
                    </li>
                    <li>
                      <span class="title">상품금액 합계</span>
                      <span class="total">{{ HconCommonUtils.format.addWon(quoteInfo.totalPrice) }}</span>
                    </li>
                    <li>
                      <span class="title">할인금액 합계</span>
                      <span class="total">{{ HconCommonUtils.format.addWon(quoteInfo.totalDiscount) }}</span>
                    </li>
                    <li class="last">
                      <span class="title">최종 견적금액 합계</span>
                      <strong class="total">{{ HconCommonUtils.format.addWon(quoteInfo.totalAmount) }}</strong>
                    </li>
                  </ul>
                </td>
              </tr>
            </tfoot>
            <tbody v-if="quoteInfo.items.length > 0">
              <tr v-for="(item, index) in quoteInfo.items" :key="index">
                <td class="xs pl34">
                  <div class="product-box">
                    <div class="thumb-wrap mr16">
                      <NuxtLink :to="item.proLink" class="thumb-img">
                        <img :src="item.thumbnail" :alt="item.name">
                      </NuxtLink>
                    </div>
                    <div class="product-info">
                      <NuxtLink :to="item.proLink">
                        <p class="product-tit">{{ item.company }}</p>
                        <p class="product-detail">{{ item.name }}</p>
                      </NuxtLink>
                    </div>
                  </div>
                </td>
                <td class="small fs15">{{ HconCommonUtils.format.addWon(item.unitPrice) }}</td>
                <td class="small fs15">{{ HconCommonUtils.format.expComma(item.count) }}</td>
                <td class="small fs15">{{ HconCommonUtils.format.addWon(item.totalAmount) }}</td>
                <td class="small fs15">{{ HconCommonUtils.format.addWon(item.discount) }}</td>
                <td class="small right pr34">
                  <p class="font-bold text-green">{{ HconCommonUtils.format.addWon(item.discountAmount) }}</p>
                  <p class="fs14 mt10 text-gray02">{{ HconCommonUtils.format.expComma(item.discountRate) }}%할인</p>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6" class="nodata">주문 정보 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
        <div class="mt32">
          <h5 class="title fs18 font-bold">Hcon 구매안내</h5>
          <ul class="dot-list black mt18">
            <li class="fs15">온라인 견적서의 금액은 1원 단위가 자동 절사됩니다.</li>
            <li class="fs15">당사 사정에 따라 견적 내용은 변경될 수 있습니다.</li>
            <li class="fs15">쿠폰의 기본 유효기간은 발송일 기준 30일이며, 상품별 유효기간이 다를 수 있으므로 상품 상세 정보와 유의사항을 확인해 주시기 바랍니다.</li>
            <li class="fs15">본 상품은 유가증권으로 비과세 상품이며, 세금계산서 발행이 불가합니다.</li>
            <li class="fs15">견적서 내 할인율은 고객 선택에 따라 표기되며, 실제 구매 시 고객님의 이용등급 할인율이 적용됩니다. 등급 변동 시 당사 등급 정책이 적용됩니다.</li>
            <li class="fs15">진행 중인 이벤트 조건이 변경될 경우 할인율이 달라질 수 있습니다. 이 경우 견적 유효기간(14일)과 관계없이 기존 이벤트 가격으로 구매가 불가할 수 있습니다.</li>
          </ul>
        </div>
      </div>
      <div class="popup-footer jc-c">
        <div class="button-box col2">
          <button v-if="!isPrinted" ype="button" @click="handlePrint(true)" class="btn lg">인쇄/저장하기</button>
        </div>
      </div>
    </BasePopup>
  </div>
</template>
<script lang="ts" setup>
import BasePopup from '@/components/com/HconComBasePopup.vue'

import { ref, computed, onMounted } from 'vue'
import { usePopup } from '@/composables/hconUsePopup'
import { ESTIMATE_CODE } from "@/constants/hconMessageConstants"
import type { QuotationWriteResDto } from '~/types/estimate/backend-dto-types';
import { usePrint } from '@/composables/hconUsePrint'

//////////////////////////////////////////////
// 초기 화면 로드 & 기본 세팅
//////////////////////////////////////////////

const { printPage } = usePrint('#print-area') // 인쇄
const { showAlert } = usePopup() // 팝업
const isPopupOpen = ref(false)
const fetchBuilder  = useHconFetchBuilder() // 공통 조회 fetch
// const props = defineProps<{ estimateData: EstimateForm }>()
const quoteInfo = ref<QuoteData>()
const isPrinted = ref(false)
const emit = defineEmits(['close'])
type QuoteViewType = 'WRITE' | 'DETAIL'
const viewType = ref<QuoteViewType>('WRITE')

interface EstimateForm {
  companyName: string
  managerName: string
  estimateName: string
  qttnNo: string
  estimateCrtDtKor: string
  estimateCrtDt: string
  totalQuantity: number
  totalOriginalAmt: number
  totalDiscountAmt: number
  totalPaymentAmt: number
  totalCashableAmt: number
  selectedProducts: SelectedProduct[]
}

// 선택 상품 타입 정의
interface SelectedProduct {
  id: number | string
  gdsCd : string
  dspGdsCd : string
  src: string
  alt: string
  brandName: string
  productName: string
  productPercent: number
  total: number
  discountCharge: number
  limitPeriod: number
  isCashable: boolean
  payments: PaymentMethods
  inpCount: string | number
  isSoldOut: boolean
  gdsAmt: number      // 상품금액 * 수량 (할인전 총액)
  gdsQttnAmt: number  // 할인가 * 수량 (실제 판매 총액)
  gdsDcAmt: number    // 총 할인금액
}

// 선택 상품안에 결제 가능 수단 타입 정의
interface PaymentMethods {
  hcoin: boolean
  pcoin: boolean
  card: boolean
  account: boolean
}

const transFormData = (raw : EstimateForm) => {

  let qttnNo
  let estimateCrtDtKor
  let estimateCrtDt

  if(viewType.value === 'WRITE') {
    qttnNo = '인쇄 시 자동 채번'
    estimateCrtDtKor = HconCommonUtils.format.todayDateKor(true)
    estimateCrtDt = HconCommonUtils.format.todayDateKor(false)
  } else {
    qttnNo = raw.qttnNo
    const year = raw.estimateCrtDt.slice(0, 4);
    const month = raw.estimateCrtDt.slice(4, 6);
    const day = raw.estimateCrtDt.slice(6, 8);
    estimateCrtDtKor = year + '년 ' + month + '월 '+ day + '일'
    estimateCrtDt = raw.estimateCrtDt
  }

  return {
    quoteNo: qttnNo, 
    dateKor: estimateCrtDtKor,
    date: estimateCrtDt,
    title: raw.estimateName,
    buyer: {
      name: raw.companyName,
      manager: raw.managerName,
    },
    provider: {
      name: '(주)현대이지웰',
      owner: '박종선',
      address: '서울특별시 서대문구 충정로 23, 8층 일부, 9, 10층 \n(충정로 3가, 풍산빌딩)',
      industry: '서비스',
      product: '전자상거래',
      manager: '복민주',
    },
    totalCount: raw.totalQuantity,        // 견적수량 합계
    totalPrice: raw.totalOriginalAmt,     // 상품금액 합계
    totalDiscount: raw.totalDiscountAmt,  // 할인금액 합계
    totalAmount: raw.totalPaymentAmt,     // 최종 견적금액 합계
    items: (raw.selectedProducts || []).map((item: SelectedProduct) => {
      
      let thumbnail
      let qty = Number(item.inpCount)
      let rowAmount
      let rowFinalAmount
      let rowDiscountAmount

      // 상품 상세 계산
      if(viewType.value === 'WRITE') {
        thumbnail = item.src
        rowAmount = item.total * qty // 상품금액 * 수량 (할인전 총액)
        rowFinalAmount = item.discountCharge * qty // 할인가 * 수량 (실제 판매 총액)
        rowDiscountAmount = (item.total - item.discountCharge) * qty // 총 할인금액
      } else {
        thumbnail = cu.getFileFullUrl(item.src)
        rowAmount = item.gdsAmt // 상품금액 * 수량 (할인전 총액)
        rowFinalAmount = item.gdsQttnAmt // 할인가 * 수량 (실제 판매 총액)
        rowDiscountAmount = item.gdsDcAmt // 총 할인금액
      }

      return {
        id: viewType.value === 'WRITE' ? item.id : item.dspGdsCd + "_" + item.gdsCd,
        dspGdsCd: item.dspGdsCd,
        gdsCd: item.gdsCd,
        thumbnail: thumbnail,
        proLink: '/', // 추후 상품링크...
        company: item.brandName,
        name: item.productName, 
        unitPrice: item.total,              // 상품단가
        count: item.inpCount,               // 수량
        totalAmount: rowAmount,             // 상품금액 = 상품금액 * 수량 (할인전 총액)
        discount: rowDiscountAmount,        // 할인금액 = 총 할인금액
        discountAmount: rowFinalAmount,     // 최종 견적금액 = 할인가 * 수량 (실제 판매 총액)
        discountRate: item.productPercent   // 할인율
      }
    })
  }
}

// 팝업 닫힘
const handleClose = () => {
  isPopupOpen.value = false
  emit('close')
}

// 팝업 시작
const handleOpen = (type: QuoteViewType, param?: EstimateForm | string) => {

  viewType.value = type

  if(type === 'WRITE') {
    if(param !== undefined) {
      quoteInfo.value = transFormData(param as EstimateForm)
      handlePopupOpen()
    }
  } else {
    // 견적서 상세보기 DB조회
    getEstimateListDetail(param as string)
  }
}

// 팝업 열기
const handlePopupOpen = () => {
  isPopupOpen.value = true
}

const isLogin = computed(() => {
  const userKey = useHconAuthInfo().getIfPossible()?.userContext.userKey;
  return userKey !== undefined && userKey !== null && userKey !== ''
})

//////////////////////////////////////////////
// 화면 값 세팅
//////////////////////////////////////////////

interface QuoteItem {
  id: number | string
  dspGdsCd: string
  gdsCd: string
  thumbnail: string
  proLink: string
  company: string
  name: string
  unitPrice: number
  count: string | number
  totalAmount: number
  discountAmount: number
  discount: number
  discountRate: number
}

interface QuoteData {
  quoteNo: string
  dateKor: string
  date: string
  title: string
  buyer: {
    name: string
    manager: string
  }
  provider: {
    name: string
    owner: string
    address: string
    industry: string
    product: string
    manager: string
  }
  totalCount: number
  totalPrice: number
  totalDiscount: number
  totalAmount: number
  items: QuoteItem[]
}

const formatAmountKr = computed(() => {
  const numberUnits = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'],
        tenUnits = ['', '십', '백', '천'],
        thousandUnits = ['', '만', '억', '조'];

  const amount = quoteInfo.value?.totalAmount.toString() || '0'

  const formatResult = Array.from({ length: amount.length }, (_, i) => {
    const digit = amount.length - i - 1,
          num = Number(amount.substring(i, i+1))
    if(digit%4 === 0){
      return numberUnits[num] + thousandUnits[(Math.floor(digit/4))]
    }else if(num !== 0){
      return numberUnits[num] + tenUnits[(digit%4)]
    } 
  })

  return formatResult.join('')
})


//////////////////////////////////////////////
// 인쇄/저장
//////////////////////////////////////////////

const handlePrint = (isPrint: boolean) => { 

  let finalPayload
  let fetchBuilderResult

  // viewType 따른 동작 분기
  if(viewType.value === 'WRITE') {

    finalPayload = {
        qttnNm: quoteInfo.value?.title               // 견적명
      , qttnCrtDt: quoteInfo.value?.date             // 견적생성일자
      , totQty: quoteInfo.value?.totalCount          // 전체견적상품수량
      , totOrglAmt: quoteInfo.value?.totalPrice      // 정상판매합계금액
      , totDcAmt: quoteInfo.value?.totalDiscount     // 할인합계금액
      , totPymtAmt: quoteInfo.value?.totalAmount     // 최종견적금액
      , chocGoodsLst: quoteInfo.value?.items.map(p => ({
            hcDspGdsCd: p.dspGdsCd
          , hcGdsCd: p.gdsCd
          , ordQty: p.count              // 견적상품수량
          , nrmlSellPrc: p.unitPrice     // 정상판매가격
          , dcRt: p.discountRate         // 할인율
      }))
      , loginYn: isLogin.value
    }
    
    // 저장
    fetchBuilderResult = fetchBuilder.post<AjaxResult<QuotationWriteResDto>>('/api/v1/order/estimate')
                          .body(finalPayload)
                          .progressMessage("잠시만 기다려주세요...")
                          .build()
  } else {

    finalPayload = {
      quoteNum: quoteInfo.value?.quoteNo               // 견적명
    }

    // 업데이트
    fetchBuilderResult = fetchBuilder.post<AjaxResult<QuotationWriteResDto>>('/api/v1/order/estimate/history')
                          .body(finalPayload)
                          .progressMessage("잠시만 기다려주세요...")
                          .build()
  }

  // API 호출
  fetchBuilderResult
    .execute()
    .then((result) => {
          if(result.resultCode != '200') {
            showAlert({
              title: '알림',
              message: result.resultMessage,
              confirmText: '확인'
            })
          } else {

            if(quoteInfo.value) {

              if(viewType.value === 'WRITE') {
                quoteInfo.value = {
                  ...quoteInfo.value
                  , quoteNo: String(result.data.qttnNo) // 견적번호 세팅
                }
              }

              isPrinted.value = true
              nextTick(() => {
                
                if (isPrint) {
                  printPage()
                }

                showAlert({
                  title: '알림',
                  message: ESTIMATE_CODE.ALT_HCON_9065,
                  confirmText: '확인',
                  onConfirm: () => {
                    // handleClose()
                  }
                })
              })
            }
          }
        })
}


//////////////////////////////////////////////
// 견적서 불러오기
//////////////////////////////////////////////

import type { QuotationDetailResDto } from '@/types/estimate/backend-dto-types';

// 견적서 불러오기
const getEstimateListDetail = async (quoteNum: string) => {
  const fetchBuilderResult = 
  fetchBuilder.get<AjaxResult<QuotationDetailResDto>>(`/api/v1/order/estimate/${quoteNum}`)
    .build()
    .execute()
    .then((res: any) => {
        if(res.resultCode != '200') {
          showAlert({
            title: '알림',
            message: res.resultMessage,
            confirmText: '확인'
          })
        } else {
          quoteInfo.value = transFormData(res.data)
          handlePopupOpen()
        }
    })
}

defineExpose({ handleOpen, handleClose });

</script>
<style lang="scss">
  @use "@/assets/scss/pc/order-hcon.scss" as *;
  @use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>